import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '404 — SitsCom';
  }, []);

  return (
    <div className="not-found">
      <div className="not-found-code">404</div>
      <h2>Page not found</h2>
      <p>The page you're looking for doesn't exist or has been moved.</p>
      <button className="btn btn-primary" onClick={() => navigate('/home')}>
        Find subjects
      </button>
    </div>
  );
};

export default NotFound;
